import { toast } from 'react-toastify';
toast.configure({ position: 'top-center', hideProgressBar: true });
export default toast;
